.container {
  color: #231E19;

  img {
    border-radius: 32px;
  }
}

.title {
  text-align: center;
  font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif;
  font-size: 34px;
  font-weight: 800;
  line-height: 41px;
  letter-spacing: -0.4px;
  margin-top: 14px;
  margin-bottom: 8px;
  padding: 0 20px;

  @at-root html[lang="de"] & {
    font-size: 28px;
  }

  @media (max-width: 375px) {
    @at-root html[lang="de"] & {
      font-size: 26px;
    }
  }
}

.subtitle {
  text-align: center;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;
  padding: 0 20px;
  margin-bottom: 16px;

  span {
    font-weight: 700;
  }
}

.heroImage {
  padding: 0 20px;

  img {
    width: 100%;
  }
}

// Dark mode
:global body.dark {
  :local {

    .container {
      color: #FFFBF2;
    }

  }
}